var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPasswordHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1441px",
    height: "248px",
    viewBox: "0 0 1920",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blue_wavy_bg2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop-0.3---forget-password",
    transform: "translate(1.000000, 0.000000)",
    fill: "#ECF9FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.805519,-596.194481 L665.740865,-596.194481 C614.020449,-576.962934 591.147702,-478.88038 597.122625,-301.946819 C601.675026,-167.137933 652.933044,3.14495209 665.740865,209.144239 C670.610807,287.471741 598.495164,422.640083 597.122625,574.367515 C596.609973,631.038556 619.48272,720.851224 665.740865,843.805519 L843.805519,843.805519 L843.805519,-596.194481 Z",
    id: "blue_wavy_bg2",
    transform: "translate(720.000000, 123.805519) rotate(-90.000000) translate(-720.000000, -123.805519) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordHeader);
export default __webpack_public_path__ + "static/media/ForgotPasswordHeader.846d45bcf76bd696574a1c44daa624e7.svg";
export { ForwardRef as ReactComponent };